import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const PreviousLink = styled(Link)`
  margin-right: auto;
  order: 1;
`

const NextLink = styled(Link)`
  margin-left: auto;
  order: 2;
`
const FlexBox = styled.div`
    display: flex; 
    flex-flow: row wrap;
    justify-content: space-around;
`

const PostLinks = props => {
    return (
        <>
            <FlexBox>
                {props.previous && (
                    <PreviousLink to={`/news/${props.previous.slug}/`}>
                    &#8592; Previous
                    </PreviousLink>
                )}
                {props.next && (
                    <NextLink to={`/news/${props.next.slug}/`}>
                        Next &#8594;
                    </NextLink>
                )}
            </FlexBox>
        </>
    )
}

export default PostLinks